/* =============================================================
   KLARHEIT 2027 — PDP behaviors (k27-pdp.js)
   Ported from design prototype pdp.js + pdp-df.js.
   Vanilla JS, no dependencies. Loaded by sections/k27-pdp-buybox.liquid.
   - Galerie: dots + "1 / N" counter (scroll-snap carousel)
   - Farb-Chips: Variante + Preis + Galerie-Sprung + Sticky-Bar-Sync
   - Bundles (DEEP FOCUS): Variante + Preis/Anker/Tagespreis + Paket-Liste
   - Sticky ATC bar: zeigt sich nach der Buy-Box, versteckt sich am Footer
   - FAQ: nur ein <details> offen
   - Remote ATC (.js-atc-remote, z.B. Finale): submitted das Buy-Box-Formular
   Echte Warenkorb-Logik macht Dawn (product-form.js + cart-drawer).
   ============================================================= */
(function () {
  'use strict';

  function debounce(fn, ms) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  /* ---------- Galerie ---------- */
  function initGallery(gal) {
    var track = gal.querySelector('[data-gal-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.gal-slide');
    var dotsWrap = gal.querySelector('[data-gal-dots]');
    var countEl = gal.querySelector('[data-gal-count]');
    var prevBtn = gal.querySelector('[data-gal-prev]');
    var nextBtn = gal.querySelector('[data-gal-next]');
    var dots = [];
    var current = 0;

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Bild ' + (i + 1));
        if (i === 0) dot.classList.add('on');
        dot.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function setActive(i) {
      i = Math.max(0, Math.min(i, slides.length - 1));
      current = i;
      if (countEl) countEl.textContent = (i + 1) + ' / ' + slides.length;
      dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
      if (prevBtn) prevBtn.disabled = (i <= 0);
      if (nextBtn) nextBtn.disabled = (i >= slides.length - 1);
    }

    function goTo(i) {
      i = Math.max(0, Math.min(i, slides.length - 1));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    track.addEventListener('scroll', debounce(function () {
      setActive(Math.round(track.scrollLeft / track.clientWidth));
    }, 60), { passive: true });

    gal.k27GoTo = goTo;
    if (slides.length <= 1) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
    }
    setActive(0);
  }

  /* ---------- Buy-Box: Chips + Bundles ---------- */
  function initPdp(root) {
    var gal = root.querySelector('[data-k27-gal]');
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var submitBtn = form ? form.querySelector('button[name="add"]') : null;
    var pv = root.querySelector('[data-bb-price]');
    var pa = root.querySelector('[data-bb-anchor]');
    var perday = root.querySelector('[data-bb-perday]');
    var colorName = root.querySelector('[data-color-name]');
    var sticky = document.querySelector('[data-k27-sticky]');
    var sbColor = sticky ? sticky.querySelector('[data-sb-color]') : null;
    var sbName = sticky ? sticky.querySelector('[data-sb-name]') : null;
    var sbPrice = sticky ? sticky.querySelector('[data-sb-price]') : null;

    function setAvailability(ok) {
      if (!submitBtn) return;
      var span = submitBtn.querySelector('span');
      if (ok) {
        submitBtn.removeAttribute('disabled');
        if (span) span.textContent = submitBtn.dataset.addLabel || 'In den Warenkorb';
      } else {
        submitBtn.setAttribute('disabled', 'disabled');
        if (span) span.textContent = submitBtn.dataset.soldOutLabel || 'Ausverkauft';
      }
    }

    function setAnchor(value) {
      if (!pa) return;
      if (value) {
        pa.textContent = value;
        pa.hidden = false;
      } else {
        pa.hidden = true;
      }
    }

    /* Farb-Chips */
    var chips = root.querySelectorAll('.bb-swatch');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          c.classList.remove('on');
          c.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('on');
        chip.setAttribute('aria-pressed', 'true');
        if (colorName) colorName.textContent = chip.dataset.color || '';
        if (sbColor) sbColor.textContent = chip.dataset.color || '';
        if (idInput && chip.dataset.variantId) idInput.value = chip.dataset.variantId;
        if (pv && chip.dataset.price) pv.textContent = chip.dataset.price;
        setAnchor(chip.dataset.compare);
        setAvailability(chip.dataset.available !== 'false');
        if (gal && gal.k27GoTo && chip.dataset.mediaPosition) {
          gal.k27GoTo(parseInt(chip.dataset.mediaPosition, 10) - 1);
        }
      });
    });

    /* Bundles (DEEP FOCUS) */
    var bundles = root.querySelectorAll('.bb-bundle');
    bundles.forEach(function (b) {
      b.addEventListener('click', function () {
        bundles.forEach(function (x) {
          x.classList.remove('on');
          x.setAttribute('aria-checked', 'false');
        });
        b.classList.add('on');
        b.setAttribute('aria-checked', 'true');
        if (b.dataset.bundle) root.setAttribute('data-bundle', b.dataset.bundle);
        /* Variante nur setzen, wenn eine gueltige id vorhanden ist —
           niemals auf leer setzen (sonst bricht der Warenkorb). */
        if (idInput && b.dataset.variantId) idInput.value = b.dataset.variantId;
        /* Menge aus dem Bundle in das versteckte quantity-Feld (echte
           Paket-Varianten: qty 1; das Paket steckt in der Variante). */
        if (qtyInput && b.dataset.qty) qtyInput.value = b.dataset.qty;
        if (pv && b.dataset.price) pv.textContent = b.dataset.price;
        setAnchor(b.dataset.anchor);
        if (perday && b.dataset.perday) perday.textContent = b.dataset.perday;
        if (sbName && b.dataset.name) sbName.textContent = b.dataset.name + ' · ' + (b.dataset.days || '');
        if (sbPrice && b.dataset.price) sbPrice.textContent = b.dataset.price + ' · ' + (b.dataset.perday || '');
        setAvailability(b.dataset.available !== 'false');
      });
    });

    /* Gratis-Zugaben (Becher/Sticker): jedes Bundle traegt
       data-gifts="variantId:qty,...". Nach dem Add den Warenkorb lesen und
       die Zugaben auf die SOLL-Menge auffuellen (Bundle-Menge x Zugaben).
       BEWUSST netzwerk-basiert statt Dawn-Events: Slide Cart kapert den
       Submit, Dawns cartUpdate feuert dann nie. Nur auffuellen, nie
       reduzieren (manuell gekaufte Becher bleiben unangetastet).
       Passende BXGY-Automatikrabatte setzen die Zugaben auf 0 EUR. */
    function parseGifts(str) {
      if (!str) return [];
      return str.split(',').map(function (pair) {
        var p = pair.split(':');
        return { id: parseInt(p[0], 10), quantity: parseInt(p[1], 10) || 1 };
      }).filter(function (g) { return g.id > 0; });
    }
    var giftMap = {}; /* bundleVariantId -> gifts[] */
    bundles.forEach(function (b) {
      if (b.dataset.variantId && b.dataset.gifts) {
        giftMap[b.dataset.variantId] = parseGifts(b.dataset.gifts);
      }
    });
    function topUpGifts() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var required = {}; /* giftVariantId -> Sollmenge */
          var present = {};  /* variantId -> Istmenge */
          cart.items.forEach(function (i) { present[i.variant_id] = (present[i.variant_id] || 0) + i.quantity; });
          cart.items.forEach(function (i) {
            var gifts = giftMap[String(i.variant_id)];
            if (gifts) gifts.forEach(function (g) {
              required[g.id] = (required[g.id] || 0) + g.quantity * i.quantity;
            });
          });
          var toAdd = [];
          Object.keys(required).forEach(function (gid) {
            var missing = required[gid] - (present[gid] || 0);
            if (missing > 0) toAdd.push({ id: parseInt(gid, 10), quantity: missing, properties: { _gratis: 'Gratis-Zugabe' } });
          });
          if (toAdd.length) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: toAdd })
            });
          }
        })
        .catch(function () {});
    }
    if (form && Object.keys(giftMap).length) {
      /* Click in der CAPTURE-Phase statt form-submit: Slide Cart kapert den
         Klick und verhindert das submit-Event komplett. Capture feuert
         garantiert vor jedem App-Handler. Deckt Buybox-, Sticky- und
         Finale-Buttons ab (.js-atc / .js-atc-remote). */
      document.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest('.js-atc, .js-atc-remote')) return;
        setTimeout(topUpGifts, 1400);
        setTimeout(topUpGifts, 3200); /* zweiter Pass, falls der Add langsam war */
      }, true);
    }
  }

  /* ---------- Sticky ATC bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-k27-sticky]');
    var buybox = document.getElementById('buybox');
    if (!bar || !buybox) return;
    var footer = document.querySelector('.k27.footer') || document.querySelector('footer');

    function onScroll() {
      var past = buybox.getBoundingClientRect().bottom < 0;
      var nearFooter = footer
        ? footer.getBoundingClientRect().top < window.innerHeight * 0.9
        : false;
      bar.classList.toggle('show', past && !nearFooter);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------- FAQ: nur ein Item offen ---------- */
  function initFaq() {
    document.querySelectorAll('.k27 .faq-list').forEach(function (list) {
      list.querySelectorAll('details.faq-item').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          list.querySelectorAll('details.faq-item[open]').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  /* ---------- Remote ATC (Finale-Button etc.) ---------- */
  function initRemoteAtc() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-atc-remote');
      if (!btn) return;
      var form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;
      e.preventDefault();
      var submit = form.querySelector('button[name="add"]');
      if (submit && submit.hasAttribute('disabled')) {
        var buybox = document.getElementById('buybox');
        if (buybox) buybox.scrollIntoView({ behavior: 'smooth' });
        return;
      }
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }

  /* ---------- Loox-Fallbacks: statische Elemente nur zeigen, wenn Loox
     nicht mountet. BEWUSST zeitgesteuerte Polls statt MutationObserver:
     Loox mutiert sein Widget beim Mount laufend; ein Observer darauf
     (plus Fallback-Toggles, die Loox-Relayouts ausloesten) hat die Seite
     beim Scrollen eingefroren. Polls sind reentranzfrei und billig. ---------- */
  function pollLooxFallback(widget, fallbacks) {
    var delays = [800, 2000, 4000, 7000];
    function apply() {
      var mounted = widget ? widget.childElementCount > 0 : false;
      fallbacks.forEach(function (el) { el.hidden = mounted; });
      return mounted;
    }
    if (!widget) { fallbacks.forEach(function (el) { el.hidden = false; }); return; }
    delays.forEach(function (ms, i) {
      setTimeout(function () {
        // Letzter Poll entscheidet endgueltig; fruehe Polls decken den
        // Normalfall (Loox mountet schnell) ohne Flackern ab.
        if (apply() && i < delays.length - 1) return;
      }, ms);
    });
  }

  function initLooxFallback() {
    var fallback = document.querySelector('[data-bb-rating-fallback]');
    if (!fallback) return;
    var widget = document.querySelector('.buybox .loox-rating');
    pollLooxFallback(widget, [fallback]);
  }

  function initLooxReviews() {
    var fallbacks = Array.prototype.slice.call(
      document.querySelectorAll('[data-loox-fallback], [data-loox-agg-fallback]')
    );
    if (!fallbacks.length) return;
    var mount = document.getElementById('looxReviews');
    pollLooxFallback(mount, fallbacks);
  }

  function init() {
    document.querySelectorAll('[data-k27-gal]').forEach(initGallery);
    document.querySelectorAll('[data-k27-pdp]').forEach(initPdp);
    initSticky();
    initFaq();
    initRemoteAtc();
    initLooxFallback();
    initLooxReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
